export default __webpack_public_path__ + "static/media/Human5.6603958d.png";